import { App } from "@app/interfaces"
import {
  Logout,
  Login,
  Telegram,
  ShoppingCart,
  Hail,
  TableChart,
  People,
  Analytics,
  JoinInner,
  DirectionsWalk,
  MoveUp,
  RateReview,
  Send,
  ListAlt,
  ElderlyWoman,
  ContactMail,
  CurrencyBitcoin,
  PointOfSale,
  Link,
  Schedule,
  Smartphone,
  List,
  AnalyticsOutlined,
  Message,
  MarkChatRead,
  Chat,
  ManageSearch,
  Search,
  BarChart,
  SmartToy,
  Router,
  Groups,
  Forum,
  AccountCircle,
  Bolt,
  Hub,
  EventRepeat,
  Diversity3,
  ViewModule,
  CalendarMonth,
  DynamicFeed,
  PlaylistPlay,
  MenuBook,
  PhotoLibrary,
} from "@mui/icons-material"

export const menu: App.RecursiveMenuItem[] = [
  {
    title: "ADV",
    role: App.UserRole.MANAGER,
    moduleRole: App.ModuleName.ADV,
    icon: ContactMail,
    isOpen: true,
    items: [
      {
        title: "Заказы",
        url: "/adv/orders",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.ADV,
        icon: ListAlt,
      },
      {
        title: "Материалы",
        url: "/adv/contents",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.ADV,
        icon: PhotoLibrary,
      },
      {
        title: "Контрагенты",
        url: "/adv/agents",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.ADV,
        icon: ElderlyWoman,
      },
      {
        title: "Платежи",
        url: "/adv/payments",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.ADV,
        icon: PointOfSale,
      },
      {
        title: "Пополнения",
        url: "/adv/top-up",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.ADV,
        icon: CurrencyBitcoin,
      },
      {
        title: "Аналитика",
        url: "/adv/analytics",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.ADV,
        icon: AnalyticsOutlined,
      },
    ],
  },
  {
    title: "Telegram",
    role: App.UserRole.USER,
    icon: Telegram,
    isOpen: true,
    items: [
      {
        title: "Пригласительные ссылки",
        url: "/telegram/chats",
        role: App.UserRole.USER,
        moduleRole: App.ModuleName.TG_INVITE_LINKS,
        icon: Link,
      },
      {
        title: "Просмотр чатов",
        url: "/telegram/chat-viewer",
        role: App.UserRole.USER,
        moduleRole: App.ModuleName.TG_BOT_CHAT,
        icon: Chat,
      },
      {
        title: "Анализ чата",
        url: "/telegram/chat-analyze",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.TG_CHAT_ANALYZE,
        icon: ManageSearch,
      },
      {
        title: "Мониторинг ботов",
        url: "/telegram/bot-monitor",
        role: App.UserRole.MANAGER,
        accessPolicy: App.AccessPolicy.BOT_MONITOR_READ,
        icon: SmartToy,
      },
      {
        title: "Участники НЧ",
        url: "/telegram/nc-members",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.NC,
        icon: People,
      },
      {
        title: "События НЧ",
        url: "/telegram/nc-updates",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.NC,
        icon: RateReview,
      },
      {
        title: "Рассылки",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.TG_MAILING,
        icon: Send,
        isOpen: true,
        items: [
          {
            title: "Создать рассылку",
            url: "/telegram/mailings/new",
            role: App.UserRole.MANAGER,
            moduleRole: App.ModuleName.TG_MAILING,
            icon: Message,
          },
          {
            title: "История рассылок",
            url: "/telegram/mailings/list",
            role: App.UserRole.MANAGER,
            moduleRole: App.ModuleName.TG_MAILING,
            icon: MarkChatRead,
          },
        ],
      },
      {
        title: "Гостевые боты",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.TG_MAILING,
        icon: SmartToy,
        isOpen: true,
        items: [
          {
            title: "Боты",
            url: "/telegram/guest-bots/bots",
            role: App.UserRole.MANAGER,
            moduleRole: App.ModuleName.TG_MAILING,
            icon: SmartToy,
          },
          {
            title: "Шаблоны",
            url: "/telegram/guest-bots/templates",
            role: App.UserRole.MANAGER,
            moduleRole: App.ModuleName.TG_MAILING,
            icon: Message,
          },
          {
            title: "Привязки",
            url: "/telegram/guest-bots/bindings",
            role: App.UserRole.MANAGER,
            moduleRole: App.ModuleName.TG_MAILING,
            icon: Link,
          },
          {
            title: "Чаты и рассылки",
            url: "/telegram/guest-bots/chats",
            role: App.UserRole.MANAGER,
            moduleRole: App.ModuleName.TG_MAILING,
            icon: Forum,
          },
          {
            title: "Логи",
            url: "/telegram/guest-bots/logs",
            role: App.UserRole.MANAGER,
            moduleRole: App.ModuleName.TG_MAILING,
            icon: List,
          },
        ],
      },
      {
        title: "Публикации",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.POST_BOT,
        icon: Telegram,
        isOpen: true,
        items: [
          {
            title: "Каналы",
            url: "/telegram/post-bot/channels",
            role: App.UserRole.MANAGER,
            moduleRole: App.ModuleName.POST_BOT,
            icon: Smartphone,
          },
          ...[
            ["templates", "Шаблоны"],
            ["publications", "Библиотека публикаций"],
            ["placements", "Размещения"],
            ["media", "Медиа"],
          ].map(([path, title]) => ({
            title,
            url: `/telegram/post-bot/${path}`,
            role: App.UserRole.MANAGER,
            accessPolicy: App.AccessPolicy.POST_BOT_READ,
            icon: path === "media" ? PhotoLibrary : ListAlt,
          })),
        ],
      },
      {
        title: "TGStat",
        url: "tgstat",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.TGSTAT,
        icon: Analytics,
      },
    ],
  },
  {
    title: "Маркетплейсы",
    role: App.UserRole.MANAGER,
    moduleRole: App.ModuleName.MARKETPLACE,
    icon: ShoppingCart,
    isOpen: true,
    items: [
      {
        title: "Конфигурация МП",
        url: "/marketplace/products",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.MARKETPLACE,
        icon: JoinInner,
        isOpen: true,
        items: [
          {
            title: "Реализация",
            url: "/marketplace/realization/list",
            role: App.UserRole.MANAGER,
            moduleRole: App.ModuleName.MARKETPLACE,
            icon: PointOfSale,
          },
          {
            title: "Партии",
            url: "/marketplace/realization/batches",
            role: App.UserRole.MANAGER,
            moduleRole: App.ModuleName.MARKETPLACE,
            icon: ListAlt,
          },
        ],
      },
      {
        title: "Курьеры",
        url: "/marketplace/couriers-statistic",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.MARKETPLACE,
        icon: DirectionsWalk,
      },
      {
        title: "Продажи",
        url: "/marketplace/sales-statistic",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.MARKETPLACE,
        icon: Analytics,
      },
      {
        title: "Аналитика кладов",
        url: "/marketplace/kraken-analytics",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.MARKETPLACE,
        icon: BarChart,
      },
      {
        title: "Таблица простоя",
        url: "/marketplace/emptytime",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.MARKETPLACE,
        icon: TableChart,
      },
      {
        title: "Перегрузка",
        url: "/marketplace/reloading",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.MARKETPLACE,
        icon: MoveUp,
      },
    ],
  },
  {
    title: "Персонал",
    role: App.UserRole.MANAGER,
    moduleRole: App.ModuleName.STAFF_SCHEDULE,
    icon: CalendarMonth,
    isOpen: true,
    items: [
      {
        title: "График",
        url: "/staff-schedule/grid",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.STAFF_SCHEDULE,
        icon: Schedule,
      },
      {
        title: "Типы смен",
        url: "/staff-schedule/shift-types",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.STAFF_SCHEDULE,
        icon: ListAlt,
      },
    ],
  },
  {
    title: "HR",
    url: "hr",
    role: App.UserRole.MANAGER,
    moduleRole: App.ModuleName.HR,
    icon: Hail,
  },
  {
    title: "Sherlok",
    url: "/osint/sherlok",
    role: App.UserRole.MANAGER,
    moduleRole: App.ModuleName.SHERLOK,
    icon: Search,
  },
  {
    title: "Userbot",
    role: App.UserRole.MANAGER,
    moduleRole: App.ModuleName.USERBOT,
    icon: SmartToy,
    isOpen: true,
    items: [
      {
        title: "Аккаунты и сессии",
        url: "/userbot/accounts",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.USERBOT,
        icon: AccountCircle,
      },
      {
        title: "Заявки на вступление",
        url: "/userbot/join-requests",
        role: App.UserRole.MANAGER,
        accessPolicy: App.AccessPolicy.USERBOT_TRACKING_READ,
        icon: ListAlt,
      },
      {
        title: "Карантин заявок",
        url: "/userbot/join-recovery",
        role: App.UserRole.MANAGER,
        accessPolicy: App.AccessPolicy.USERBOT_TRACKING_READ,
        icon: ListAlt,
      },
      {
        title: "Обнаруженные диалоги",
        url: "/userbot/dialogs",
        role: App.UserRole.MANAGER,
        accessPolicy: App.AccessPolicy.USERBOT_TRACKING_READ,
        icon: Forum,
      },
      {
        title: "Проходы опроса",
        url: "/userbot/dialog-passes",
        role: App.UserRole.MANAGER,
        accessPolicy: App.AccessPolicy.USERBOT_TRACKING_READ,
        icon: ListAlt,
      },
      {
        title: "Уточнения участия",
        url: "/userbot/membership-clarifications",
        role: App.UserRole.MANAGER,
        accessPolicy: App.AccessPolicy.USERBOT_TRACKING_READ,
        icon: People,
      },
      {
        title: "Роли (пулы)",
        url: "/userbot/roles",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.USERBOT,
        icon: Groups,
      },
      {
        title: "Прокси",
        url: "/userbot/proxies",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.USERBOT,
        icon: Router,
      },
      {
        title: "Шаблоны",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.USERBOT,
        icon: ViewModule,
        isOpen: true,
        items: [
          {
            title: "Галерея",
            url: "/userbot/templates",
            role: App.UserRole.MANAGER,
            moduleRole: App.ModuleName.USERBOT,
            icon: ViewModule,
          },
          {
            title: "Редактор",
            url: "/userbot/templates/new",
            role: App.UserRole.MANAGER,
            moduleRole: App.ModuleName.USERBOT,
            icon: Bolt,
          },
        ],
      },
      {
        title: "Цепочки",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.USERBOT,
        icon: Hub,
        isOpen: true,
        items: [
          {
            title: "Конструктор",
            url: "/userbot/chains/new",
            role: App.UserRole.MANAGER,
            moduleRole: App.ModuleName.USERBOT,
            icon: Bolt,
          },
          {
            title: "Цепочки",
            url: "/userbot/chains",
            role: App.UserRole.MANAGER,
            moduleRole: App.ModuleName.USERBOT,
            icon: ListAlt,
          },
        ],
      },
      {
        title: "Расписания",
        url: "/userbot/scheduled",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.USERBOT,
        icon: EventRepeat,
      },
      {
        title: "Триггеры",
        url: "/userbot/triggers",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.USERBOT,
        icon: Bolt,
      },
      {
        title: "Членство",
        url: "/userbot/memberships",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.USERBOT,
        icon: Diversity3,
      },
      {
        title: "Запуски по аккаунтам",
        url: "/userbot/batches",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.USERBOT,
        icon: PlaylistPlay,
      },
      {
        title: "Словари профилей",
        url: "/userbot/profile-dictionaries",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.USERBOT,
        icon: MenuBook,
      },
      {
        title: "Массовые операции",
        url: "/userbot/mass-ops",
        role: App.UserRole.MANAGER,
        moduleRole: App.ModuleName.USERBOT,
        icon: DynamicFeed,
      },
    ],
  },
  {
    title: "Вход",
    url: "/login",
    role: App.UserRole.ANON,
    exactRole: true,
    icon: Login,
  },
  { title: "Выход", url: "/logout", role: App.UserRole.USER, icon: Logout },
]
